import { makeStyles } from "@mui/styles";
import CloseIcon from "@mui/icons-material/Close";
import { Box, Dialog, DialogContent, IconButton } from "@mui/material";
import { ReactComponent as AlertIcon } from "../../../assets/alert.svg";
import { PrimaryButton, SecondaryButton } from "../Buttons";

const useStyles = makeStyles(() => ({
  dialogContent: {
    width: 460,
    height: 260,
    padding: 16,
  },
  closeIconContainer: {
    height: 40,
    position: "absolute",
    right: "5px",
    top: "5px",
  },
  contentContainer: {
    height: "calc(100% - 80px)",
  },
  actionContainer: {
    height: 40,
    display: "flex",
    alignItems: "center",
    justifyContent: "space-evenly",
  },
  alertIconContainer: {
    height: 72,
    padding: "5px 0px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginTop: "20px"
  },
  TextContainer: {
    padding: 5,
    textAlign: "center",
  },
}));

export default function DeleteConfirmationModal({
  cancelHandler,
  cancelText = "Cancel",
  contentText = "Are you sure want to delete?",
  submitHandler,
  submitText = "Delete",
  isOpen,
  SecondaryText = "",
  hideCancelButton = false
}: any) {
  const classes = useStyles();

  return (
    <Dialog open={isOpen}>
      <DialogContent className={classes.dialogContent}>
        <Box className={classes.closeIconContainer}>
          <IconButton onClick={cancelHandler}>
            <CloseIcon />
          </IconButton>
        </Box>
        <Box className={classes.contentContainer}>
          <Box className={classes.alertIconContainer}>
            <AlertIcon />
          </Box>
          <Box className={classes.TextContainer}>{contentText}</Box>
          <Box className={classes.TextContainer}>{SecondaryText}</Box>
        </Box>
        <Box className={classes.actionContainer}>
          {!hideCancelButton && (
            <SecondaryButton style={{ width: "40%" }} onClick={cancelHandler}>
              {cancelText}
            </SecondaryButton>
          )}
          <PrimaryButton style={{ width: "40%" }} onClick={submitHandler}>
            {submitText}
          </PrimaryButton>
        </Box>
      </DialogContent>
    </Dialog>
  );
}
